import { Loader2, Save } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { LAYOUTS, perPage } from "@/lib/tagLayouts";

function LayoutButton({ id, active, onPick }) {
  const L = LAYOUTS[id];
  return (
    <button onClick={() => onPick(id)} data-testid={`tags-layout-${id}`} aria-pressed={active}
      className={`rounded-xl border px-3 py-2.5 text-left transition-colors ${active ? "border-slate-900 bg-slate-900 text-white" : "border-slate-200 bg-white text-slate-800 hover:border-slate-400"}`}>
      <div className="text-sm font-bold">{L.label}</div>
      <div className={`font-mono text-[10.5px] ${active ? "text-amber-300" : "text-slate-400"}`}>{L.kind === "a4" ? L.size : "thermal label"}</div>
    </button>
  );
}

const FIELD_LABELS = { price: "Price", business_name: "Business name", batch: "Batch no", expiry: "Expiry" };

export function TagOptions({ settings, set, pharmacy, onSave, saving }) {
  const L = LAYOUTS[settings.layout];
  const fields = pharmacy ? ["price", "business_name", "batch", "expiry"] : ["price", "business_name"];
  return (
    <div className="space-y-5 rounded-2xl border border-slate-200 bg-white p-4" data-testid="tags-options">
      <div>
        <div className="eyebrow">A4 sticker sheet</div>
        <div className="mt-2 grid grid-cols-3 gap-2">{["a4_24", "a4_40", "a4_65"].map((id) => <LayoutButton key={id} id={id} active={settings.layout === id} onPick={(v) => set({ layout: v, start_position: 1 })} />)}</div>
      </div>
      <div>
        <div className="eyebrow">Thermal label roll</div>
        <div className="mt-2 grid grid-cols-3 gap-2">{["th_50x25", "th_38x25", "th_40x30"].map((id) => <LayoutButton key={id} id={id} active={settings.layout === id} onPick={(v) => set({ layout: v, start_position: 1 })} />)}</div>
      </div>
      {L.kind === "a4" && (
        <label className="flex items-center justify-between gap-3 text-sm font-semibold text-slate-800">
          <span>Start at label position <span className="font-normal text-slate-500">(reuse a partly used sheet)</span></span>
          <input type="number" min={1} max={perPage(L)} value={settings.start_position} data-testid="tags-start-position-input"
            onChange={(e) => set({ start_position: Math.min(perPage(L), Math.max(1, parseInt(e.target.value, 10) || 1)) })}
            className="money h-10 w-20 rounded-lg border border-slate-200 text-center outline-none focus:border-slate-900" />
        </label>
      )}
      <div>
        <div className="eyebrow">On the tag</div>
        <div className="mt-2 text-xs text-slate-500">Name with the barcode directly under it is always printed.</div>
        <div className="mt-3 grid grid-cols-1 gap-2.5 sm:grid-cols-2">
          {fields.map((f) => (
            <label key={f} className="flex items-center justify-between rounded-xl border border-slate-200 px-3 py-2.5 text-sm font-semibold text-slate-800">
              {FIELD_LABELS[f]}
              <Switch checked={settings.fields[f]} onCheckedChange={(v) => set({ fields: { ...settings.fields, [f]: v } })} data-testid={`tags-field-${f}`} />
            </label>
          ))}
        </div>
      </div>
      <button onClick={onSave} disabled={saving} data-testid="tags-save-settings-button" className="flex h-11 w-full items-center justify-center gap-2 rounded-xl border border-slate-900 text-sm font-bold text-slate-900 hover:bg-slate-900 hover:text-white disabled:opacity-50">
        {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} Save tag settings
      </button>
    </div>
  );
}
